import React, { ReactElement } from 'react'
import { Icon, Box, Tooltip } from '@chakra-ui/react'
import { TTableCell } from '../types'
import { useColor } from '../../../theme'
import { Info } from '@rw1/shared-lib'


export const IconCell: TTableCell<{ icon: ReactElement | undefined, hasMissingVersions?: boolean, label?: string }> = ({ icon, hasMissingVersions, label }) => {
  const color = useColor({ nuance: 'grey', palette: 'colors' })
  const fileHasMissingVersionsColor = useColor({ nuance: 'orange', palette: 'colors' })

  return (
    <Box height="7" position="relative" width="7">
      <Icon color={color} height="7" width="7">
        {icon}
      </Icon>
      {hasMissingVersions && (
        <Tooltip
          borderRadius="md"
          fontSize="md"
          label={label}
          maxWidth="none"
          sx={{
            whiteSpace: "pre-wrap",
          }}
        >
          <Info
            bottom="0"
            color={fileHasMissingVersionsColor}
            position="absolute"
            right="-2"
          />
        </Tooltip>
      )}
    </Box>
  )
}
